<!--
  OUTRAS FORMAS DE PAGAMENTO
-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
   props: {
        obj: { type: Object },
    },

    data () {
        return {
          errorMessage: '',

          formapagamentoobj: {
              descricao: 'A Combinar',
              obs: 'Entraremos em contato para acertar os detalhes do pagamento.',
              desconto: null,
              id: null,
              habilitarRetirada: true,
              excluido: false,
          },

        }
    },

    computed: {
        title: function () {
            return 'Adicionar forma de pagamento'
        }
    },

    filters: {

    },

    methods: {

        closeForm () {
            this.$emit('closeform')
        },

        validarDados () {

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.handleConfirmar()
                }
            })

        },

        handleConfirmar () {
          this.$emit('confirma', this.formapagamentoobj)
        }

    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            this.$refs.descricao.focus()
        })
    },

    created () {
        if (this.obj)
            this.formapagamentoobj = {...this.obj}
    }

}

</script>

<template>
  <transition>
    <div id="mymodal" class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; max-width: 100%">
          <div class="nb-modal-header">
            <h4 class="def-title">{{ title }}</h4>
            <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="nb-modal-scrollable-body">
            <div class="row">
                <form-field ref="descricao" v-model="formapagamentoobj.descricao" case="normal" type="text" col="12" label="Descrição"
                    name="text" :v-errors="errors" v-validate="{ required: true, max: 50 }"></form-field>
            </div>
            <div class="row">
              <form-field v-model="formapagamentoobj.obs" type="memo" col="12" label="Instruções"
                  name="obs" :v-errors="errors" v-validate="{ max: 1000 }"></form-field>
            </div>
            <div class="row">
                <div class="col-md-12 mb-2">
                    <label class="lbl-edit">
                        <input type="checkbox" v-model="formapagamentoobj.habilitarRetirada"> Habilitar esta forma de pagamento na retirada
                    </label>
                </div>
            </div>
            <div class="row">
              <form-field v-model="formapagamentoobj.desconto" type="value" :precision="2" col="3" label="Desconto" addon="%"
                  name="desconto" :v-errors="errors" v-validate="{ required: false }"></form-field>
            </div>
            <div class="nb-modal-scrollable-footer">
                <v-button ref="btnConfirm" label="Ok" title="" :nb-btdef="true" @click="validarDados"></v-button>
                <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm"></v-button>
            </div>
          </div>
      </div>
    </div>


  </transition>

</template>

<style>


</style>



// WEBPACK FOOTER //
// src/forms-loja/config-formaspagamento-form-loja.vue